import { Grid2, Stack, useTheme } from "@mui/material";
import { Outlet } from "react-router";
import { TabHeaderCatalog } from "./TabHeaderCatalog";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { ScoreComparisonCard } from "../ScoreComparisonCard";
import { useEntityScores } from "src/context/Scores/useEntityScores";

type Props = unknown;
export const CatalogLayout = (props: Props) => {
    const theme = useTheme();
    const { scoresWithVariations, lastSelectedVariation } = useEntityScores();
    const { actionPlanData } = useActionsContext();

    if (scoresWithVariations.length === 0) {
        // No scores.
        // Error page ?
        return;
    }

    const selectedOption = lastSelectedVariation ?? scoresWithVariations[0];
    const _actionPlanData = actionPlanData.find((i) => {
        return i.scoreId === selectedOption.scoreId && i.variationId === selectedOption.variationId;
    });

    if (_actionPlanData === undefined) {
        return;
    }

    return (
        <Stack width={"100%"} padding={theme.spacing(0, 6)}>
            <Stack flexDirection={"row"} justifyContent={"space-between"} padding={theme.spacing(2, 0)}>
                <TabHeaderCatalog />
            </Stack>
            <Grid2 container spacing={theme.spacing(2)} columns={{ xl: 12, lg: 12, md: 8, sm: 4 }}>
                <Grid2 size={8}>
                    <Outlet />
                </Grid2>
                <Grid2 size={{ lg: 4, md: 8, sm: 4 }}>
                    <ScoreComparisonCard
                        actionPlanData={_actionPlanData}
                        selectedOption={selectedOption}
                        position={"vertical"}
                        disableFooter={true}
                        catalogSelector={true}
                    />
                </Grid2>
            </Grid2>
        </Stack>
    );
};
